import { ItemTypeConsts } from 'client/util/Constants';
import { cloneDeep } from 'lodash';
import { ospPolicyNames } from 'client/util/Constants/OsPatchMgmtConstants';
import CollectionApi from 'client/api/v2/CollectionApi';

class PolicyApi extends CollectionApi {
  constructor(policyType) {
    super('/api/v2/policies', {
      skip: 0,
      limit: 50,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'name',
        operator: 'search',
        value: '',
      }],
    });
    this.policyType = policyType;
  }

  setNameFilters(filters) {
    const policyNames = {
      [ItemTypeConsts.osPatchManagement]: ospPolicyNames,
      [ItemTypeConsts.browserPatchManagement]: ['chrome_universal'],
    }[this.policyType];

    const newFilters = cloneDeep(filters);

    if (this.policyType !== ItemTypeConsts.policy) {
      newFilters.push({
        name: 'template.name',
        operator: 'in',
        value: policyNames.join('|'),
      });
    }

    return newFilters;
  }

  fetch(skip, limit, sort, searchTerm, cancelToken, filters = [], pageToken, skipToken) {
    const newFilters = this.setNameFilters(filters);

    return super.fetch(
      skip,
      limit,
      sort,
      searchTerm,
      cancelToken,
      newFilters,
      pageToken,
      skipToken,
    );
  }

  fetchAll(searchTerm, boundItems, filters = []) {
    const newFilters = this.setNameFilters(filters);

    return super.fetchAll(searchTerm, boundItems, newFilters);
  }

  findPoliciesByName(names) {
    return super.fetch(null, 50, null, null, null, [{
      name: 'template.name',
      operator: 'in',
      value: names.join('|'),
    }]);
  }

  fetchTotalPolicyCountByName(names) {
    return super.fetch(null, 1, null, null, null, [{
      name: 'template.name',
      operator: 'in',
      value: names.join('|'),
    }]);
  }

  /**
   * Get the total amount of Policies of a particular Operative System
   * @param {*} OS
   */
  getOsPoliciesCount(OS) {
    return super.fetch(null, 50, null, null, null, [{
      name: 'template.osMetaFamily',
      operator: 'eq',
      value: OS,
    }]);
  }

  fetchTotalPolicyCount() {
    return super.fetch(null, 1, null, null, null, []);
  }
}
export function createPolicyApi(policyType) {
  return new PolicyApi(policyType);
}

export default new PolicyApi(ItemTypeConsts.policy);
